/**
 * The language people talk in (core lang.ts G1): remembered per browser, default the browser's language. And the
 * server translation for languages parsed on the server, registered by the session once an org is known.
 */
import { useSyncExternalStore } from "react";
import { speechLangFor, type Translate } from "@logwave/core";

const KEY = "cc.speechLang";
const subs = new Set<() => void>();
function read(): string {
  let saved: string | undefined;
  try { saved = localStorage.getItem(KEY) ?? undefined; } catch { /* private mode */ }
  return speechLangFor(saved, typeof navigator === "undefined" ? undefined : navigator.language);
}
let current = read();
export function setSpeechLang(code: string) {
  current = speechLangFor(code);
  try { localStorage.setItem(KEY, current); } catch { /* private mode */ }
  subs.forEach((f) => f());
}
export const useSpeechLang = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => current, () => current);

let translator: Translate | undefined;
export function setVoiceTranslator(fn: Translate | undefined) { translator = fn; }
export const voiceTranslator = () => translator;
